var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container dashboard-marketing-page"},[_c('portal',{attrs:{"to":"page-name"}},[_vm._v("Dashboard")]),_c('div',{staticClass:"dashboard-title"},[_vm._v("Dashboard")]),_c('div',{staticClass:"text-info"},[_vm._v("Em desenvolvimento")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }